import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtMoney, fmtDate } from "@/lib/format";

export const Route = createFileRoute("/_authenticated/admin/users")({
  component: AdminUsers,
});

function AdminUsers() {
  const { data: users = [] } = useQuery({
    queryKey: ["admin-users"],
    queryFn: async () => {
      const { data } = await supabase.from("profiles").select("*").order("created_at", { ascending: false });
      return data ?? [];
    },
  });

  return (
    <div className="glass rounded-2xl overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Balance</TableHead>
            <TableHead>Deposited</TableHead>
            <TableHead>Withdrawn</TableHead>
            <TableHead>Ref code</TableHead>
            <TableHead>Joined</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((u) => (
            <TableRow key={u.id}>
              <TableCell>
                <div className="text-sm">{u.full_name ?? "—"}</div>
                <div className="text-[11px] text-muted-foreground">{u.email}</div>
              </TableCell>
              <TableCell className="font-mono">{fmtMoney(u.balance)}</TableCell>
              <TableCell className="font-mono">{fmtMoney(u.total_deposited)}</TableCell>
              <TableCell className="font-mono">{fmtMoney(u.total_withdrawn)}</TableCell>
              <TableCell className="font-mono text-xs">{u.referral_code}</TableCell>
              <TableCell className="text-xs text-muted-foreground">{fmtDate(u.created_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}